import { CountryCode } from '@/graphql/api'
import type { Locale } from '@/i18n'

const defaultLocale = 'en-gb'

/** Country ISO code to locale / language (ISO 639-1 or regional English catalogue). */
const localeByCountry = {
    AD: 'ca',
    AE: 'ar',
    AF: 'fa',
    AG: 'en',
    AI: 'en',
    AL: 'sq',
    AM: 'hy',
    AO: 'pt',
    AQ: 'en',
    AR: 'es',
    AS: 'en-us',
    AT: 'de',
    AU: 'en-au',
    AW: 'nl',
    AX: 'sv',
    AZ: 'az',
    BA: 'bs',
    BB: 'en',
    BD: 'bn',
    BE: 'nl',
    BF: 'fr',
    BG: 'bg',
    BH: 'ar',
    BI: 'rn',
    BJ: 'fr',
    BL: 'fr',
    BM: 'en',
    BN: 'ms',
    BO: 'es',
    BQ: 'nl',
    BR: 'pt',
    BS: 'en',
    BT: 'dz',
    BV: 'en',
    BW: 'en',
    BY: 'be',
    BZ: 'en',
    CA: 'en-ca',
    CC: 'en-au',
    CD: 'fr',
    CF: 'fr',
    CG: 'fr',
    CH: 'de',
    CI: 'fr',
    CK: 'en-nz',
    CL: 'es',
    CM: 'fr',
    CN: 'zh',
    CO: 'es',
    CR: 'es',
    CU: 'es',
    CV: 'pt',
    CW: 'nl',
    CX: 'en-au',
    CY: 'el',
    CZ: 'cs',
    DE: 'de',
    DJ: 'ar',
    DK: 'da',
    DM: 'en',
    DO: 'es',
    DZ: 'ar',
    EC: 'es',
    EE: 'et',
    EG: 'ar',
    EH: 'ar',
    ER: 'en',
    ES: 'es',
    ET: 'am',
    FI: 'fi',
    FJ: 'en',
    FK: 'en',
    FM: 'en',
    FO: 'fo',
    FR: 'fr',
    GA: 'fr',
    GB: 'en-gb',
    GD: 'en',
    GE: 'ka',
    GF: 'fr',
    GG: 'en',
    GH: 'en',
    GI: 'en',
    GL: 'kl',
    GM: 'en',
    GN: 'fr',
    GP: 'fr',
    GQ: 'es',
    GR: 'el',
    GS: 'en',
    GT: 'es',
    GU: 'en-us',
    GW: 'pt',
    GY: 'en',
    HK: 'zh',
    HM: 'en-au',
    HN: 'es',
    HR: 'hr',
    HT: 'ht',
    HU: 'hu',
    ID: 'id',
    IE: 'en-ie',
    IL: 'he',
    IM: 'en',
    IN: 'hi',
    IO: 'en',
    IQ: 'ar',
    IR: 'fa',
    IS: 'is',
    IT: 'it',
    JE: 'en',
    JM: 'en',
    JO: 'ar',
    JP: 'ja',
    KE: 'sw',
    KG: 'ky',
    KH: 'km',
    KI: 'en',
    KM: 'ar',
    KN: 'en',
    KP: 'ko',
    KR: 'ko',
    KW: 'ar',
    KY: 'en',
    KZ: 'ru',
    LA: 'lo',
    LB: 'ar',
    LC: 'en',
    LI: 'de',
    LK: 'si',
    LR: 'en',
    LS: 'st',
    LT: 'lt',
    LU: 'fr',
    LV: 'lv',
    LY: 'ar',
    MA: 'ar',
    MC: 'fr',
    MD: 'ro',
    ME: 'sr',
    MF: 'fr',
    MG: 'mg',
    MH: 'en',
    MK: 'mk',
    ML: 'fr',
    MM: 'my',
    MN: 'mn',
    MO: 'zh',
    MP: 'en-us',
    MQ: 'fr',
    MR: 'ar',
    MS: 'en',
    MT: 'mt',
    MU: 'en',
    MV: 'dv',
    MW: 'en',
    MX: 'es',
    MY: 'ms',
    MZ: 'pt',
    NA: 'en',
    NC: 'fr',
    NE: 'fr',
    NF: 'en-au',
    NG: 'en',
    NI: 'es',
    NL: 'nl',
    NO: 'no',
    NP: 'ne',
    NR: 'en',
    NU: 'en-nz',
    NZ: 'en-nz',
    OM: 'ar',
    PA: 'es',
    PE: 'es',
    PF: 'fr',
    PG: 'tpi',
    PH: 'en',
    PK: 'ur',
    PL: 'pl',
    PM: 'fr',
    PN: 'en',
    PR: 'en-us',
    PS: 'ar',
    PT: 'pt',
    PW: 'pau',
    PY: 'gn',
    QA: 'ar',
    RE: 'fr',
    RO: 'ro',
    RS: 'sr',
    RU: 'ru',
    RW: 'rw',
    SA: 'ar',
    SB: 'en',
    SC: 'fr',
    SD: 'ar',
    SE: 'sv',
    SG: 'en',
    SH: 'en',
    SI: 'sl',
    SJ: 'no',
    SK: 'sk',
    SL: 'en',
    SM: 'it',
    SN: 'fr',
    SO: 'so',
    SR: 'nl',
    SS: 'en',
    ST: 'pt',
    SV: 'es',
    SX: 'en',
    SY: 'ar',
    SZ: 'en',
    TC: 'en',
    TD: 'fr',
    TF: 'fr',
    TG: 'fr',
    TH: 'th',
    TJ: 'tg',
    TK: 'en-nz',
    TL: 'pt',
    TM: 'tk',
    TN: 'ar',
    TO: 'to',
    TR: 'tr',
    TT: 'en',
    TV: 'tvl',
    TW: 'zh',
    TZ: 'sw',
    UA: 'uk',
    UG: 'sw',
    UM: 'en-us',
    US: 'en-us',
    UY: 'es',
    UZ: 'uz',
    VA: 'it',
    VC: 'en',
    VE: 'es',
    VG: 'en',
    VI: 'en-us',
    VN: 'vi',
    VU: 'bi',
    WF: 'fr',
    WS: 'sm',
    YE: 'ar',
    YT: 'fr',
    ZA: 'en-za',
    ZM: 'en',
    ZW: 'sn',
} as const satisfies Record<CountryCode, string>

export function getLocaleByCountry(
    countryCode: CountryCode | undefined
): Locale {
    if (!countryCode) {
        return defaultLocale
    }

    return localeByCountry[countryCode]
}

if (import.meta.vitest) {
    const { describe, test, expect } = import.meta.vitest

    describe('localeByCountry', () => {
        test('covers every country code', () => {
            expect(Object.keys(localeByCountry).sort()).toEqual(
                Object.values(CountryCode).sort()
            )
        })

        test('maps countries to their language or regional English locale', () => {
            expect(getLocaleByCountry('BG')).toBe('bg')
            expect(getLocaleByCountry('GB')).toBe('en-gb')
            expect(getLocaleByCountry('US')).toBe('en-us')
            expect(getLocaleByCountry('DE')).toBe('de')
        })
    })
}
